import React from 'react';
import PropTypes from 'prop-types';
import DateTimeFilter from '../../common/reportTable/filters/DateTimeFilter';
import TextFilter from '../../common/reportTable/filters/TextFilter';
import SelectFilter from '../../common/reportTable/filters/SelectFilter';
import { DefectStatus } from '../../../models/bikeDefects/DefectStatus';
import './styles.scss';

class FiltersPanel extends React.Component {
  constructor(props) {
    super(props);
    this.handleDelete = this.handleDelete.bind(this);
  }

  getFilterValue(id) {
    return this.props.filteredBy.find(f => f.id === id);
  }

  handleDelete(deleteFunction) {
    this.props.onFilteredChange(deleteFunction(this.props.filteredBy));
  }

  render() {
    return (
      <div className="filters-panel flex-row flex-wrap" >
        <DateTimeFilter filter={this.getFilterValue("reportedAt")} onDelete={this.handleDelete} readonly label="Od" />
        <TextFilter filter={this.getFilterValue("bikeNumber")} onDelete={this.handleDelete} readonly label="Obiekt" />
        <TextFilter filter={this.getFilterValue("reportedBy.firstName")} onDelete={this.handleDelete} readonly label="Imię" />
        <TextFilter filter={this.getFilterValue("reportedBy.lastName")} onDelete={this.handleDelete} readonly label="Nazwisko" />
        <TextFilter filter={this.getFilterValue("reportedBy.phoneNumber")} onDelete={this.handleDelete} readonly label="Nr telefonu" />
        <TextFilter filter={this.getFilterValue("reportedBy.email")} onDelete={this.handleDelete} readonly label="Email" />
        <SelectFilter filter={this.getFilterValue("status")} items={DefectStatus} onDelete={this.handleDelete} readonly label="Status" />
      </div>
    );
  }
}

FiltersPanel.propTypes = {
  onFilteredChange: PropTypes.func,
  filteredBy: PropTypes.array
};

export default FiltersPanel;
